import React, { ReactElement, useState } from "react";
import AccordionStyle from "Componentes/Accordion/style.module.scss";
import flecha from "Componentes/Accordion/imgs/flecha.png";

export type AccordionProps = {
  answer: string;
  reply: string | ReactElement<JSX.Element>;
};

const AccordionItem: React.FC<AccordionProps> = ({ answer, reply }) => {
  const [isActive, setIsActive] = useState(false);
  return (
    <div className='d-block w-100'>
      <div
        className={`${AccordionStyle.accordionAnswer}`}
        onClick={() => setIsActive(!isActive)}>
        <div>{answer}</div>
        <img
          className={`${isActive ? AccordionStyle.above : AccordionStyle.down}`}
          width={30}
          height={30}
          alt='Flecha'
          src={flecha}
        />
      </div>
      <div
        className={`${
          isActive ? AccordionStyle.deploy : AccordionStyle.contract
        } ${AccordionStyle.accordionReply}`}
        title='clase-estilos'>
        {reply}
      </div>
    </div>
  );
};

export default AccordionItem;
